import { IOmniaShell } from "../../shell"
import { Dialog } from "../../shell/dialog"
import { defineDirective } from "../../utils/angular"
import { AppSession } from "../appSession"

/// <reference path="../../shell/dialog.ts" />

/** @internal */
export class ConnectPopupCtrl extends Dialog {

    static create(): ng.IDirective {
        return defineDirective(ConnectPopupCtrl, "shared/apps/connect/popup.html")
    }

    static $inject = ["$scope", "OmniaShell"]

    private session: AppSession

    constructor($scope: ng.IScope, shell: IOmniaShell) {

        super($scope, shell)

        const s: AppSession = this.session = this.arguments.session

        s.getConnection(false).then(() => {

            $scope.$watch(() => s.connected && (s.status === 0), ok => {
                if (ok) {
                    this.close()
                }
            })

        })

    }

    get app() {
        return this.session ? this.session.app : null
    }

    close() {
        if (!this.session.connected) {
            this.session.cancelConnection().then(r => super.close([]))
        } else {
            super.close([])
        }
    }


}
